import { fromEvent } from 'rxjs';

export default class BrokenImageHandler {
  onImageErrorSubscriptions = [];

  static handleImageError = (event) => {
    if (event.target.tagName === 'IMG') {
      const img = event.target;
      if (!img.hasAttribute('data-fallback-applied')) {
        img.src = img.getAttribute('data-on-error-src');
        img.setAttribute('data-fallback-applied', 'true'); // Prevent retries

        const picture = img.closest('picture');
        if (picture) {
          picture.querySelectorAll('source').forEach((element) => element.remove());
        }
      }
    }
  }

  bind(selector, container=document) {
    const imgElements = Array.from(container.querySelectorAll(selector));
    imgElements.forEach((imgElement) => {
      this.onImageErrorSubscriptions.push(fromEvent(imgElement, 'error')
        .subscribe(BrokenImageHandler.handleImageError));
    });
  }

  unbind() {
    this.onImageErrorSubscriptions.forEach((subscription) => subscription.unsubscribe());
    this.onImageErrorSubscriptions = [];
  }
}
